// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
  with slight edits made by Me!
*/
*, *::before, *::after {
    box-sizing: border-box;
}
*:not(dialog) {
    margin: 0;
}
body {
    line-height: calc(1em + 0.5rem);
    -webkit-font-smoothing: antialiased;
    height: 100vh;
    background: rgb(114, 98, 255);
}
img {
    max-width: 100%;
    font-style: italic;
    background-repeat: no-repeat;
    background-size: cover;
    height: auto;
    vertical-align: middle;
    shape-margin: 1rem;

}
input, button, textarea, select {
    font: inherit;
}
p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
}
p {
    text-wrap: pretty;
}
h1, h2, h3, h4, h5, h6 {
    text-wrap: balance;
}
ul, li {
    padding: 0;
    margin: 0;
}
li {
    list-style: none;
}
body {
    display: grid;
    grid-auto-flow: row;
}
header {
    color:  rgb(251, 251, 255);
    margin-top: 1rem;
    padding: 1rem;
    place-self: center;
}
main {
    display: grid;
    grid-template-columns: 350px 1fr;
    grid-template-rows: 95vh 84px;
    gap: 1rem;
    padding: 1rem;
}
.info-area, .log-area, .score-area, .button-area, .title, .info-footer, footer {
    border: 4px rgba(39, 0, 179, 0.842) solid;
    border-top: rgb(133, 145, 255) 4px solid;
    border-left-color: rgb(133, 145, 255);
    background: rgb(216, 216, 255);
    padding: 1rem;
}
.info-area {
    overflow-y: scroll;
    scrollbar-color: rgba(39, 0, 179, 0.842) rgb(133, 145, 255);
    gap: 2rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 1rem;

    .title {
        width: 28ch;
    }

    .button-area {
        width: 28ch;
        gap: 1rem;
        display: flex;
        justify-content: center;
    }
    .score-area {
        display: flex;
        gap: 2rem;
        flex-direction: column;
        align-items: start;
        width: 28ch;
        & > h4 {
            text-align: left;
            padding: 0.4rem;
            
            > h4 {
                color: rgb(2, 2, 192);
            }
        }
    }

    .log-area{
        flex-shrink: 0;
        display: flex;
        flex-flow: column;
        align-items: start;
        padding: 1rem;
        margin: 1rem;
        width: 28ch;
        height: 300px;
        > ul {
            color: rgb(2, 2, 192);
            text-align: left;
            display: flex; 
            flex-direction: column;
            align-items: flex-start;
        }
    }
    .info-footer {
        width: 28ch;
        summary {
            text-align: left;
        } 
        > ul {
        display: flex;
        flex-direction: column;
        text-align: left;
        gap: 0.4rem;
        }
    }
}

.game-area {
    grid-row: span 2;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 2rem;
}

.board {
    display: flex;
    flex-wrap: wrap;
    height: 700px;
    width: 700px;
    gap: 0.14rem;    
    border: 4px rgba(39, 0, 179, 0.842) solid;
    border-top: rgb(133, 145, 255) 4px solid;
    border-left-color: rgb(133, 145, 255);
    background: rgb(171, 171, 245);
}

button[class*="grid"], div[class*="grid"] {
    width: 67px;
    height: 65px;
    border: rgba(30, 0, 163, 0.938) 4px solid;
    border-top: rgb(133, 145, 255) 4px solid;
    border-left-color: rgb(133, 145, 255);
    background: rgb(208, 211, 255);

    &[class*="CPU"]:hover, &[class*="CPU"]:focus {
        background: rgb(0, 94, 202);
    }
}

button[class^="1"]:not(button[class*="CPU"]), div[class^="1"]:not(button[class*="CPU"]) {
    background: rgb(82, 88, 177);
}
button[class^="2"], div[class^="2"] {
    position: relative;
    background: rgb(255, 201, 86);
    &::after {
        position: absolute;
        top: 22px;
        left: 18px;
        display: inline-block;
        content: "O";
        font-size: 40px;
        color: rgb(172, 117, 0);
    }
}
button[class^="3"], div[class^="3"] {
    position: relative;
    background: rgb(255, 42, 42);
    &::after {
        position: absolute;
        top: 22px;
        left: 18px;
        display: inline-block;
        content: "X";
        font-size: 40px;
        color: rgb(99, 0, 0);
    }
}
footer {
    grid-column: 1;
    grid-row: 2;
    width: 40ch;
    padding: 1rem;
    max-height: 6rem;
    & > ul {
        display: flex;
        font-size: 14px;
        gap: 1rem;
        justify-content: space-around;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;IACI,sBAAsB;AAC1B;AACA;IACI,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,mCAAmC;IACnC,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;;AAEtB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,6BAA6B;IAC7B,SAAS;IACT,aAAa;AACjB;AACA;IACI,yCAAyC;IACzC,wCAAwC;IACxC,qCAAqC;IACrC,8BAA8B;IAC9B,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,2DAA2D;IAC3D,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;;IAEjB;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,SAAS;QACT,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,SAAS;QACT,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX;YACI,gBAAgB;YAChB,eAAe;;YAEf;gBACI,qBAAqB;YACzB;QACJ;IACJ;;IAEA;QACI,cAAc;QACd,aAAa;QACb,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,WAAW;QACX,aAAa;QACb;YACI,qBAAqB;YACrB,gBAAgB;YAChB,aAAa;YACb,sBAAsB;YACtB,uBAAuB;QAC3B;IACJ;IACA;QACI,WAAW;QACX;YACI,gBAAgB;QACpB;QACA;QACA,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,yCAAyC;IACzC,wCAAwC;IACxC,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,wCAAwC;IACxC,qCAAqC;IACrC,8BAA8B;;IAE9B;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,YAAY;QACZ,eAAe;QACf,uBAAuB;IAC3B;AACJ;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;AACJ;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB;QACI,aAAa;QACb,eAAe;QACf,SAAS;QACT,6BAA6B;IACjC;AACJ","sourcesContent":["/*\n  Josh's Custom CSS Reset\n  https://www.joshwcomeau.com/css/custom-css-reset/\n  with slight edits made by Me!\n*/\n*, *::before, *::after {\n    box-sizing: border-box;\n}\n*:not(dialog) {\n    margin: 0;\n}\nbody {\n    line-height: calc(1em + 0.5rem);\n    -webkit-font-smoothing: antialiased;\n    height: 100vh;\n    background: rgb(114, 98, 255);\n}\nimg {\n    max-width: 100%;\n    font-style: italic;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: auto;\n    vertical-align: middle;\n    shape-margin: 1rem;\n\n}\ninput, button, textarea, select {\n    font: inherit;\n}\np, h1, h2, h3, h4, h5, h6 {\n    overflow-wrap: break-word;\n}\np {\n    text-wrap: pretty;\n}\nh1, h2, h3, h4, h5, h6 {\n    text-wrap: balance;\n}\nul, li {\n    padding: 0;\n    margin: 0;\n}\nli {\n    list-style: none;\n}\nbody {\n    display: grid;\n    grid-auto-flow: row;\n}\nheader {\n    color:  rgb(251, 251, 255);\n    margin-top: 1rem;\n    padding: 1rem;\n    place-self: center;\n}\nmain {\n    display: grid;\n    grid-template-columns: 350px 1fr;\n    grid-template-rows: 95vh 84px;\n    gap: 1rem;\n    padding: 1rem;\n}\n.info-area, .log-area, .score-area, .button-area, .title, .info-footer, footer {\n    border: 4px rgba(39, 0, 179, 0.842) solid;\n    border-top: rgb(133, 145, 255) 4px solid;\n    border-left-color: rgb(133, 145, 255);\n    background: rgb(216, 216, 255);\n    padding: 1rem;\n}\n.info-area {\n    overflow-y: scroll;\n    scrollbar-color: rgba(39, 0, 179, 0.842) rgb(133, 145, 255);\n    gap: 2rem;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    padding-top: 1rem;\n\n    .title {\n        width: 28ch;\n    }\n\n    .button-area {\n        width: 28ch;\n        gap: 1rem;\n        display: flex;\n        justify-content: center;\n    }\n    .score-area {\n        display: flex;\n        gap: 2rem;\n        flex-direction: column;\n        align-items: start;\n        width: 28ch;\n        & > h4 {\n            text-align: left;\n            padding: 0.4rem;\n            \n            > h4 {\n                color: rgb(2, 2, 192);\n            }\n        }\n    }\n\n    .log-area{\n        flex-shrink: 0;\n        display: flex;\n        flex-flow: column;\n        align-items: start;\n        padding: 1rem;\n        margin: 1rem;\n        width: 28ch;\n        height: 300px;\n        > ul {\n            color: rgb(2, 2, 192);\n            text-align: left;\n            display: flex; \n            flex-direction: column;\n            align-items: flex-start;\n        }\n    }\n    .info-footer {\n        width: 28ch;\n        summary {\n            text-align: left;\n        } \n        > ul {\n        display: flex;\n        flex-direction: column;\n        text-align: left;\n        gap: 0.4rem;\n        }\n    }\n}\n\n.game-area {\n    grid-row: span 2;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 2rem;\n}\n\n.board {\n    display: flex;\n    flex-wrap: wrap;\n    height: 700px;\n    width: 700px;\n    gap: 0.14rem;    \n    border: 4px rgba(39, 0, 179, 0.842) solid;\n    border-top: rgb(133, 145, 255) 4px solid;\n    border-left-color: rgb(133, 145, 255);\n    background: rgb(171, 171, 245);\n}\n\nbutton[class*=\"grid\"], div[class*=\"grid\"] {\n    width: 67px;\n    height: 65px;\n    border: rgba(30, 0, 163, 0.938) 4px solid;\n    border-top: rgb(133, 145, 255) 4px solid;\n    border-left-color: rgb(133, 145, 255);\n    background: rgb(208, 211, 255);\n\n    &[class*=\"CPU\"]:hover, &[class*=\"CPU\"]:focus {\n        background: rgb(0, 94, 202);\n    }\n}\n\nbutton[class^=\"1\"]:not(button[class*=\"CPU\"]), div[class^=\"1\"]:not(button[class*=\"CPU\"]) {\n    background: rgb(82, 88, 177);\n}\nbutton[class^=\"2\"], div[class^=\"2\"] {\n    position: relative;\n    background: rgb(255, 201, 86);\n    &::after {\n        position: absolute;\n        top: 22px;\n        left: 18px;\n        display: inline-block;\n        content: \"O\";\n        font-size: 40px;\n        color: rgb(172, 117, 0);\n    }\n}\nbutton[class^=\"3\"], div[class^=\"3\"] {\n    position: relative;\n    background: rgb(255, 42, 42);\n    &::after {\n        position: absolute;\n        top: 22px;\n        left: 18px;\n        display: inline-block;\n        content: \"X\";\n        font-size: 40px;\n        color: rgb(99, 0, 0);\n    }\n}\nfooter {\n    grid-column: 1;\n    grid-row: 2;\n    width: 40ch;\n    padding: 1rem;\n    max-height: 6rem;\n    & > ul {\n        display: flex;\n        font-size: 14px;\n        gap: 1rem;\n        justify-content: space-around;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
